<mbs-modal
  #modal
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="'shared:buttons.payMethods' | i18next">
  <div modal-body>
    <p>{{ 'shared:paymentMethodsModal.intro' | i18next }}</p>

    <mbs-payment-mode-hints />
  </div>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [attr.data-e2e]="elementsSelector.name.proceedButton"
      (click)="modal.save()">
      {{ 'shared:buttons.proceed' | i18next: { format: 'title' } }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      [attr.data-e2e]="elementsSelector.name.cancelButton"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
